import { useState } from "react";
import { CreditCard, LogOut, Globe, Trash2 } from "lucide-react";
import { useUser } from "@supabase/auth-helpers-react";
import { Link, useNavigate } from "react-router";
import { redirectToBillingPortal } from "@/integrations/stripe/client";
import i18next from "i18next";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "../components/ui/use-toast";
import { useTranslation } from "react-i18next";
import { DeleteProfile } from "../components/DeleteProfile";
import { DeleteProfileMobile } from "../components/DeleteProfileMobile";

const ProfilePage = () => {
  const user = useUser();
  const navigate = useNavigate();
  const { toast } = useToast();
  const { i18n, t } = useTranslation();

  const languages = [
    { code: 'ru', label: 'Русский' },
    { code: 'en', label: 'English' }
  ];

  const handleManageSubscription = async () => {
    try {
      await redirectToBillingPortal(i18next.language);
    } catch (error) {
      console.error("Failed to redirect to billing portal:", error);
      toast({
        title: "Error",
        description: "Could not access billing portal. Please try again.",
        variant: "destructive",
      });
    }
  };

  const handleLogout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Logout error:", error);
      toast({
        title: "Error",
        description: "Could not log out. Please try again.",
        variant: "destructive",
      });
    }
  };


  const menuItems = [
    {
      id: "russian",
      label: "Русский",
      icon: Globe,
      action: () => i18n.changeLanguage("ru"),
      hasCheckmark: true,
    },
    {
      id: "english",
      label: "English",
      icon: Globe,
      action: () => i18n.changeLanguage("en"),
    },
    {
      id: "payment",
      label: t("menu.billing"),
      icon: CreditCard,
      action: () => handleManageSubscription(),
    },
    {
      id: "delete",
      component: <DeleteProfileMobile user={user} />,
      icon: Trash2,
      danger: true,
    },
    {
      id: "logout",
      label: t("menu.logout"),
      icon: LogOut,
      action: () => handleLogout(),
      danger: true,
    },
  ];

  return (
    <div className="bg-transparent max-h-screen font-semibold px-3">
      {/* Header */}

      {/* Profile Content */}
      <div className="p-4 space-y-1">
        {/* User Email */}
        <div className="py-3 px-0">
          <Link to={`/user/${user.id}`}>
            <span className="text-gray-900 text-base dark:text-white">
              {user.email}
            </span>
          </Link>
        </div>
        <hr />
        {/* Menu Items */}
        {menuItems.map((item, i) => {
          if (item.component)
            return (<div key={item.id}>
              {item.component}
            </div>);
          return (
            <div key={item.id}>
              <button
                onClick={item.action}
                className={`w-full flex items-center justify-between py-4 px-0 text-left hover:bg-gray-50 transition-colors rounded-lg ${item.danger ? "text-gray-900" : "text-gray-900"
                  }`}
              >
                <div className="flex items-center space-x-3 dark:text-white">
                  {item.icon && <item.icon className="w-5 h-5 text-gray-600" />}
                  <span className="text-base">{item.label}</span>
                </div>
              </button>
              {i % 2 === 1 && <hr className="dark:bg-white" />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProfilePage;
